import React from 'react'
import check from '../../../assets/images/check-mark.png'

const CheckButton = props => {
  const { label, isChecked, onChange } = props
  return <div className='pair-check-button'>
    <div
      className='check'
      onClick={onChange}
    >
      {isChecked === true && <img src={check} alt='check' />}
    </div>
    <label className='label-check' htmlFor={label}>
      {label}
    </label>
  </div>
}

export default CheckButton